import { render, staticRenderFns } from "./Geography.vue?vue&type=template&id=88b09112&scoped=true"
import script from "./Geography.vue?vue&type=script&lang=js"
export * from "./Geography.vue?vue&type=script&lang=js"
import style0 from "./Geography.vue?vue&type=style&index=0&id=88b09112&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b09112",
  null
  
)

export default component.exports